import { Fragment } from "react"
import DashboardGrossV2 from "./DashboardGrossV2"

export const DashboardGrossV2Placeholder = () => {
    return <Fragment>
        <DashboardGrossV2/>
    </Fragment>
}